import { render } from "./PartsAccordionBox.vue?vue&type=template&id=9c0f6cc4&scoped=true"
import script from "./PartsAccordionBox.vue?vue&type=script&lang=js"
export * from "./PartsAccordionBox.vue?vue&type=script&lang=js"

import "./PartsAccordionBox.vue?vue&type=style&index=0&id=9c0f6cc4&scoped=true&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c0f6cc4"]])

export default __exports__